export const CM_EVENTLOG_PERMISSION = 'cm_eventlog';
export const CM_GET_RASTER_HEATMAP = 'cm_get_raster_heatmap';
export const CM_CREATE_RASTER_HEATMAP = 'cm_create_raster_heatmap';
export const CM_REBOOT = 'cm_reboot';
export const CM_SET_GAIN = 'cm_set_gain';
export const CM_COMMISSION = 'cm_commission';
export const CM_SET_SERVICE_STATE = 'cm_set_service_state'
export const COMMISSION_PERMISSION_NAME = 'cgs_commission';
export const SEARCH_COMMISSION_PERMISSION_NAME = 'cgs_search';
export const SW_DEFAULT_SWVERSION_READ = 'sw_default_swversion_read';
export const SW_PROTECTED_DEVICE_READ = 'sw_protected_device_read';
export const SW_FACTORY_DEVICE_READ = 'sw_factory_device_read';
